import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AdminAuth } from './config/auth/admin.auth';

import { AppPageNotFoundComponent } from "./components/pagenotfound/app.pagenotfound.component";
import { AppMakpakkraftMainComponent } from "./components/index/app.makpakkraft.main";
import { GeschaeftsvorgangTableComponent } from "./components/index/app.geschaeftsvorgangs.component";
import { AppMassenberechnungKraft } from "./components/index/kraft/massenberechnung/app.massenberechnung.kraft";
import { AppMaklerpaketKraft } from "./components/index/kraft/app.maklerpaket.kraft";
import { AppPaketsucheKraft } from "./components/index/kraft/app.paketsuche.kraft";
import { AppAdministrationKraft } from "./components/index/kraft/app.administration.kraft";
import { AppUploadpaketeMainComponent } from './components/index/app.uploadpakete.main';
import { AppMeinkonto } from './components/index/kraft/meinkonto/app.meinkonto';
import { AuthComponent } from './components/auth/auth.component';

const routes: Routes = [
 
  {path: 'index', component: AppUploadpaketeMainComponent},
  {path: 'index-kraft', component: AppUploadpaketeMainComponent},
  {path: 'meinkonto', component: AppUploadpaketeMainComponent},
  {path: '404', component: AppPageNotFoundComponent},
  {path: 'geschaeftsvorgang', component: GeschaeftsvorgangTableComponent},
  {path: 'ges', redirectTo: '/geschaeftsvorgang', pathMatch: 'full'},
  {path: 'index/ges', redirectTo: '/geschaeftsvorgang', pathMatch: 'full'},
  {path: 'https://maklert.allianz.de/wps/aspro/paketcockpit-frontend/ges', redirectTo: '/geschaeftsvorgang', pathMatch: 'full'},
  {path: 'https://maklert.allianz.de/wps/aspro/paketcockpit-frontend/index/ges', redirectTo: '/geschaeftsvorgang', pathMatch: 'full'},
  {path: 'massenberechnung', component: AppMassenberechnungKraft,},
  {path: 'maklerpaketKraft', component: AppMaklerpaketKraft,},
  {path: 'paketsuche', component: AppPaketsucheKraft,},
  {path: 'makpakAdmin', component: AppAdministrationKraft,},
  {
    path: 'auth',
    children: [
      { path: 'cim', component: AuthComponent },
      // Allow partial/deeper matches like /auth/cim/step or /auth/cim/anything
      { path: 'cim/**', component: AuthComponent }
    ]
  },
 // {path: '', redirectTo: '/index', pathMatch: 'full'}

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [AdminAuth],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
